import { useGameStore } from '@/store/gameStore';
import { HomeScreen } from '@/components/screens/HomeScreen';
import { CpuSetupScreen } from '@/components/screens/CpuSetupScreen';
import { LobbyScreen } from '@/components/screens/LobbyScreen';
import { AuctionScreen } from '@/components/screens/AuctionScreen';
import { BattleScreen } from '@/components/screens/BattleScreen';
import { ResultsScreen } from '@/components/screens/ResultsScreen';
import { PhaseBar } from '@/components/game/PhaseBar';
import { ErrorBoundary } from '@/components/ErrorBoundary';

const Index = () => {
  const { phase } = useGameStore();

  return (
    <ErrorBoundary>
      <PhaseBar />
      {phase === 'home' && <HomeScreen />}
      {phase === 'cpu-setup' && <CpuSetupScreen />}
      {phase === 'lobby' && <LobbyScreen />}
      {phase === 'auction' && <AuctionScreen />}
      {phase === 'battle' && <BattleScreen />}
      {phase === 'results' && <ResultsScreen />}
    </ErrorBoundary>
  );
};

export default Index;
